<template>
  <row>
    <eight-wide-column>
      <form
        id="action-form"
        class="ui form"
        style="min-width: 24.5rem">
        <input-group
          :value="action"
          :data="ActionForm"
          v-model="action"/>
      </form>
    </eight-wide-column>

    <action-preview :item="action"/>

    <!--<json-Output :json="action"/>-->
  </row>
</template>

<script>
import { ActionForm } from '../../forms/forms'
import { Action } from '../../structs/structs'

import InputGroup from '../InputGroup'
import ActionPreview from './ActionPreview'
import Row from '../utility/Row'
import EightWideColumn from '../utility/EightWideColumn'
import { constructValidator } from '../../forms/validations'

const isEditingItem = app.__vue__.$route.name.includes('Edit')

export default {
  name: 'ActionForm',
  components: { EightWideColumn, Row, ActionPreview, InputGroup },
  props: {
    existingItem: {
      type: Object,
      required: false,
      default () { return null }
    }
  },
  data () {
    return {
      ActionForm,
      action: new Action(this.existingItem || {})
    }
  },
  computed: {
    formValidator () {
      return constructValidator($, 'action-form', 'action', 'form', this.constructCustomValidatorSetters())
    }
  },
  watch: {
    action: {
      handler (newValue) {
        this.$emit('validated-item', this.formIsValid() ? newValue : null)
      },
      deep: true,
      immediate: isEditingItem
    }
  },
  mounted () {
    this.initializeFormValidator()
  },
  methods: {
    initializeFormValidator () {
      this.formValidator()
    },
    validateForm () {
      return $('#action-form').form('validate form')
    },
    formIsValid () {
      return $('#action-form').form('is valid')
    },
    constructCustomValidatorSetters () {
      return jQuery => {
        return () => {
          jQuery.fn.form.settings.rules.endDayAfterStartDay = () => {
            return (parseInt(this.action.data.options.endDay) >= parseInt(this.action.data.options.startDay))
          }
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
